export const consentServiceImplFactory = ({
  consentRepository,
}: {
  consentRepository: IConsentRepository;
}) => {
  const getConsentList: IGetConsentListService = async ({
    clinicId,
    search,
  }) => {
    try {
      const response = await consentRepository.getConsentListAPI({
        clinic_id: clinicId,
        search,
      });

      return {
        success: true,
        data: { data: response },
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const getConsentDischargeList: IGetConsentListService = async ({
    clinicId,
    search,
  }) => {
    try {
      const response = await consentRepository.getConsentListDischargeAPI({
        clinic_id: clinicId,
        search,
      });

      return {
        success: true,
        data: { data: response },
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const setConsentChange: ISetConsentChangeService = async (payload) => {
    try {
      const response = await consentRepository.setConsentChangeAPI(payload);

      return {
        success: true,
        data: { data: response },
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  return { getConsentList, getConsentDischargeList, setConsentChange };
};
